<template>
  <v-form :model-value="valid" @update:model-value="valid = $event">
    <v-dialog
      :model-value="show"
      width="500"
      persistent
      @update:model-value="$emit('update:show', $event)"
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          <span class="text-h6">Taken Filters</span>
          <v-spacer></v-spacer>
          <v-btn icon :title="'Sluiten'" @click="clear_form">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-select
            :model-value="modelValue.user_id_eq"
            :items="[{ name: '', id: '' }, ...users]"
            item-title="name"
            item-value="id"
            label="Eigenaar taak"
            prepend-icon="mdi-account-box"
            outlined
            dense
            @update:model-value="updateField('user_id_eq', $event)"
          ></v-select>

          <v-select
            :model-value="modelValue.owner_id_eq"
            :items="[{ name: '', id: '' }, ...users]"
            item-title="name"
            item-value="id"
            label="Taak aangemaakt door"
            prepend-icon="mdi-account-box"
            outlined
            dense
            @update:model-value="updateField('owner_id_eq', $event)"
          ></v-select>

          <v-select
            :model-value="modelValue.account_id_not_null"
            :items="[
              { text: '', value: '' },
              { text: 'Ja', value: 'true' },
              { text: 'Nee', value: 'false' },
            ]"
            item-title="text"
            item-value="value"
            label="Gekoppeld aan DG"
            prepend-icon="mdi-account-star"
            outlined
            dense
            @update:model-value="updateField('account_id_not_null', $event)"
          ></v-select>

          <v-select
            :model-value="modelValue.deadline_historical"
            :items="[
              { text: '', value: '' },
              { text: 'Ja', value: 'true' },
              { text: 'Nee', value: 'false' },
            ]"
            item-title="text"
            item-value="value"
            label="Verlopen"
            prepend-icon="mdi-clock-alert-outline"
            outlined
            dense
            @update:model-value="updateField('deadline_historical', $event)"
          ></v-select>

          <v-btn class="mt-2" block bottom color="warning" @click="clear_form">
            Filters verwijderen
          </v-btn>

          <v-btn
            class="mt-2"
            block
            bottom
            color="primary"
            @click="apply_filters"
          >
            Filters toepassen
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { useUsersStoreRefactor } from "@/stores/usersStoreRefactor";
import { useAuthStoreRefactor } from "@/stores/authStoreRefactor";
import { computed, ref } from "vue";

export default {
  name: "DeadlineFilterDialog",
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "update:show",
    "selected_options",
    "clear_search",
    "search",
    "close_window",
    "update:modelValue",
  ],
  setup(props, { emit }) {
    const usersStore = useUsersStoreRefactor();
    const authStore = useAuthStoreRefactor();
    const valid = ref(false);

    const users = computed(() => usersStore.users);
    const current_user = computed(() => authStore.user);

    const updateField = (field, value) => {
      const newValue = { ...props.modelValue, [field]: value };
      emit("update:modelValue", newValue);
      update_selected_options(newValue);
    };

    const update_selected_options = (values = props.modelValue) => {
      let form_values = Object.values(values);
      form_values = form_values.filter((n) => n);
      emit("selected_options", form_values.length);
    };

    const clear_form = () => {
      const cleared = {
        user_id_eq: "",
        owner_id_eq: "",
        account_id_not_null: "",
        deadline_historical: "",
        description_i_cont_all: "",
      };
      emit("update:modelValue", cleared);
      emit("selected_options", 0);
      emit("clear_search");
      emit("search");
      emit("update:show", false);
    };

    const apply_filters = () => {
      emit("search");
      emit("update:show", false);
    };

    return {
      users,
      current_user,
      updateField,
      update_selected_options,
      clear_form,
      apply_filters,
      valid,
    };
  },
};
</script>
